<template>
  <CCol
    v-bind:key="`child-${mainIndex}-${childIndex}-${index}`"
    v-for="(child, index) in children"
    xs="12"
    sm="6"
    class="under-child"
  >
    <ToolTipWrapper :child="child" />
  </CCol>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Children2 } from "@/types/jsonTypes";
import ToolTipWrapper from "@/components/ToolTipWrapper.vue";

export default defineComponent({
  name: "UnderChild",
  components: {
    ToolTipWrapper,
  },
  props: {
    children: {
      type: Object as PropType<Children2[]>,
      required: true,
    },
    mainIndex: {
      type: Number,
      required: true,
    },
    childIndex: {
      type: Number,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.under-child {
  min-height: 175px;
  padding: 0.5rem 0.5rem;

  ::v-deep(.child-wrapper) {
    background: #0f7b99;
    color: #fff;
  }
}
</style>
